import { WHITE } from "../../../constants/colors";

const backgroundColor = { default: `${WHITE}` };

export const fallbackValues = {
  backgroundColor
};
